export default {
  'survey.action.back_home': 'กลับไปที่ศูนย์สมาชิก',
  'survey.cta.register': 'สมัครสมาชิกทันที',
  'survey.cta.view_coupon': 'ดูคูปองของฉัน',
  'survey.cta.view_points': 'ดูคะแนนของฉัน',
  'survey.cta.go_member_center': 'ไปที่ศูนย์สมาชิก',
  'survey.cta.go_member_card': 'ไปที่บัตรสมาชิก',
  'survey.cta.go_coupon': 'ไปที่กระเป๋าคูปอง',
  'survey.cta.register_to_claim': 'สมัครก่อนรับของขวัญ 🎁',
  'survey.cta.join_member': 'สมัครสมาชิก!',
  'survey.welcome.question_count': '{count} ข้อ',
  'survey.welcome.estimated_minutes': 'ประมาณ {minutes} นาที',
  'survey.welcome.start': 'เริ่มตอบแบบสอบถาม',
  'survey.welcome.privacy': 'เมื่อส่งคำตอบ ถือว่าคุณยอมรับนโยบายความเป็นส่วนตัว',
  'survey.welcome.privacy_prefix': 'เมื่อส่งคำตอบ ถือว่าคุณยอมรับ',
  'survey.reward.title': 'ของขวัญพิเศษสำหรับคุณ',
  'survey.reward.member_points': 'คะแนนสมาชิก',
  'survey.reward.point_unit': 'คะแนน',
  'survey.reward.points': '{points} คะแนน',
  'survey.reward.coupon': '{name}{qty}',
  'survey.reward.coupon_fallback': 'คูปอง',
  'survey.reward.require_member': 'สมัครสมาชิกเพื่อรับรางวัล',
  'survey.question.unsupported': 'ยังไม่รองรับประเภทคำถามนี้',
  'survey.question.auth_required': 'กรุณาเข้าสู่ระบบ LINE ก่อนส่งแบบสอบถาม',
  'survey.question.submit_failed': 'ส่งไม่สำเร็จ กรุณาลองใหม่ภายหลัง',
  'survey.question.required': 'จำเป็น',
  'survey.footer.submitting': 'กำลังส่ง...',
  'survey.footer.submit': 'ส่ง',
  'survey.footer.next': 'ถัดไป',
  'survey.footer.back': 'ย้อนกลับ',
  'survey.progress.label': 'คำถาม {current}/{total}',
  'survey.district.city': 'จังหวัด/เมือง',
  'survey.district.city_placeholder': 'เลือกจังหวัด/เมือง',
  'survey.district.township': 'เขต/อำเภอ',
  'survey.district.township_placeholder': 'เลือกเขต/อำเภอ',
  'survey.text.placeholder': 'กรุณากรอกคำตอบของคุณ...',
  'survey.multi_choice.selected_count': 'เลือกแล้ว {count} รายการ',
  'survey.rating.1': 'ไม่พอใจอย่างมาก',
  'survey.rating.2': 'ไม่พอใจ',
  'survey.rating.3': 'ปานกลาง',
  'survey.rating.4': 'พอใจ',
  'survey.rating.5': 'พอใจอย่างมาก',
  'survey.rating.aria_label': '{score} คะแนน, {label}',
  'survey.rating.placeholder': 'กรุณาเลือกคะแนน',
  'survey.complete.thanks': 'ขอบคุณสำหรับคำตอบของคุณ!',
  'survey.complete.submitted': 'ส่งแบบสอบถามเรียบร้อยแล้ว',
  'survey.error.SVY001.title': 'ไม่พบแบบสอบถามนี้',
  'survey.error.SVY001.content': 'แบบสอบถามนี้ไม่มีอยู่หรือถูกลบแล้ว',
  'survey.error.SVY002.title': 'แบบสอบถามนี้ยังไม่เปิดให้ตอบ',
  'survey.error.SVY002.content': 'กรุณาตรวจสอบลิงก์แบบสอบถามหรือลองใหม่ภายหลัง',
  'survey.error.SVY003.not_started.title': 'แบบสอบถามนี้ยังไม่เริ่ม',
  'survey.error.SVY003.not_started.content': 'มีกำหนดเริ่มในวันที่ {date}',
  'survey.error.SVY003.ended.title': 'แบบสอบถามนี้สิ้นสุดแล้ว',
  'survey.error.SVY003.ended.content': 'ระยะเวลาตอบสิ้นสุดเมื่อ {date}',
  'survey.error.SVY003.title': 'แบบสอบถามนี้ยังไม่เปิดหรือสิ้นสุดแล้ว',
  'survey.error.SVY003.content': 'กรุณาตรวจสอบช่วงเวลาที่เปิดให้ตอบแบบสอบถาม',
  'survey.error.SVY009.title': 'คำเชิญนี้หมดอายุแล้ว',
  'survey.error.SVY009.content': 'ขอบคุณที่ให้ความสนใจ',
  'survey.error.SVY010.title': 'ลิงก์นี้ไม่ใช่ของคุณ',
  'survey.error.SVY010.content': 'คุณไม่สามารถใช้ลิงก์แบบสอบถามนี้เพื่อตอบได้',
  'survey.error.SVYF009.title': 'สาขานี้หยุดให้บริการชั่วคราว',
  'survey.error.SVYF009.content': 'กรุณาใช้ลิงก์แบบสอบถามของสาขาอื่น หรือลองใหม่ภายหลัง',
  'survey.error.E001.title': 'ลิงก์แบบสอบถามไม่ถูกต้อง',
  'survey.error.E001.content': 'กรุณาตรวจสอบว่าคุณเปิดลิงก์แบบสอบถามที่ครบถ้วน',
  'survey.error.auth_required.title': 'ไม่สามารถเปิดแบบสอบถามได้',
  'survey.error.auth_required.content': 'กรุณาเข้าสู่ระบบ LINE ก่อนเปิดแบบสอบถาม',
  'survey.error.default.title': 'ไม่สามารถเปิดแบบสอบถามได้',
  'survey.error.default.content': 'ตรวจสอบแบบสอบถามไม่สำเร็จ กรุณาลองใหม่ภายหลัง',
  'survey.filled.title': 'คุณเคยตอบแบบสอบถามนี้แล้ว',
  'survey.filled.content': 'แบบสอบถามนี้ตอบได้เพียงครั้งเดียว ขอบคุณที่เข้าร่วม',
  'survey.filled.recent.content':
    'คุณตอบแบบสอบถามนี้เมื่อ {completedDate} และสามารถตอบได้อีกครั้งตั้งแต่ {nextOpenDate}',
} as Record<string, string>;
